
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ExchangeSelectGrid extends _Ext.GridBase<ECommExchangeRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommExchange'; }
        protected getDialogType() { return ECommExchangeDialog; }
        protected getIdProperty() { return ECommExchangeRow.idProperty; }
        protected getInsertPermission() { return ECommExchangeRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommExchangeRow.localTextPrefix; }
        protected getService() { return ECommExchangeService.baseUrl; } 
        private autoSize; 
        constructor(container: JQuery, options) {
            super(container,options);

            var request = this.view.params as ReportFiltersRequest;
            var poscustomerid = options.GridFilters.CustomerId;
            if (poscustomerid != undefined && poscustomerid > 0) {
                request.POSCustomerId= poscustomerid;
                //(this.view.params as StockListRequest).InStock = ECommOrderItemsSelectGrid.InStock;
            } 
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
        }

        protected getColumns() {
            var _this = this;
            var columns = super.getColumns.call(this);
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(function () { return _this.rowSelection; }));

            columns.forEach(column => {
                if (column.sourceItem && column.sourceItem.editLink)
                    column.format = undefined;
            });
            return columns;
        };

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);

            return grid;
        }


        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        get selectedItems(): ECommExchangeRow[] {
            var _this = this;
            var c = this.rowSelection.getSelectedAsInt32();
            //.map(function (x) { return _this.view.getItemById(x); });
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };

        protected onViewSubmit() {
            if (!super.onViewSubmit.call(this))
                return false;
            var request = this.view.params as Serenity.ListRequest;
            
            return true;

        }
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}